goog.provide("shadow.js.shim.module$react_bootstrap$Tabs$default");
shadow.js.shim.module$react_bootstrap$Tabs$default = shadow.js.require(370, {}).default;
